// import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import * as spriteIcons from 'assets/svg/sprite'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
// import { toFixedNumber } from 'helpers/dataTransformations'
import { type ChartType } from 'types/api/analytic'
import { type iActionCard } from 'types/iTypes'

interface ISalesCard extends iActionCard {
    cardKey: string
    activeGraph?: string
    label: string
    sum: number
    percentage: number | 'X'
    salesCount: number
    onGraphClick: (cardKey: string) => void
}

const formatCurrency = (value: number | string | null | undefined) => {
    if (value == null || value === '' || isNaN(Number(value))) return '$0.00';
    const num = Number(value);
    return `$${num.toFixed(2)}`;
};

export const SalesCard = ({
    cardKey,
    activeGraph,
    label,
    sum,
    percentage,
    salesCount,
    onGraphClick,
    ...actionCardProps
}: ISalesCard) => {
    const { t } = useTranslation()
/*     const percentageIncrement = useMemo(
        () => (percentage && percentage !== 'X' ? percentage > 0 : null),
        [percentage]
    ) */

    return (
        <ActionCard
            // hasArrow={true}
            icon={<spriteIcons.IconWallet2 />}
            text={
            <span className="analytics-card-currency-container">
                <span className="analytics-card-currency">
                <span className="analytics-card-currency-value">{formatCurrency(sum)}</span>
                {percentage !== null && percentage !== undefined && percentage !== 'X' && (
                    <span
                    className={`analytics-card-currency-${
                        (percentage) >= 0 ? 'increment' : 'decrement'
                    }`}
                    >
                    {(percentage) >= 0 ? (
                        <spriteIcons.IconUpArrow />
                    ) : (
                        <spriteIcons.IconDownArrow />
                    )}
                    <span>{Math.abs(percentage)}%</span>
                    </span>
                )}
                </span>
                <span className="analytics-card-currency-type">{label}</span>
            </span>
            }
            customHtml={
                <div className='analytics-card-sales-container'>
                    <div className='analytics-card-sales-number'>
                        <div className='analytics-card-sales-number-value'>
                            {salesCount}
                        </div>
                        <div className='analytics-card-sales-number-text'>
                            {t('sales')}
                        </div>
                    </div>

                    <div
                        className={`analytics-card-sales-icon ${
                            activeGraph === cardKey
                                ? 'analytics-card-sales-icon--active'
                                : ''
                        }`}
                        onClick={() => {
                            onGraphClick(cardKey as ChartType)
                        }}
                    >
                        <spriteIcons.IconGraph color='#767676' />
                    </div>
                </div>
            }
            {...actionCardProps}
        />
    )
}
